import React, {useContext} from 'react';

import {Context} from '../../../context/dataStore';
import './Home.scss';

function BFCP_HE_LOCK() {
  const {state: {bfcp_he_lock_description}} = useContext(Context);
  //console.log({bfcp_he_lock_description});
  return(
    <div className='bfcp_ready_container center'>
      <p id='bfcp_he_lock_description'>
        {bfcp_he_lock_description}
      </p>
    </div>
  );
}
export default BFCP_HE_LOCK;